import { RadioGroup as AtomsRadioGroup } from '@wf-common/atoms'
import { withFormErrorHandling } from '../inputs/with-form-error-handling'

const RadioGroup = withFormErrorHandling(AtomsRadioGroup)
export { RadioGroup }
